import { Controller } from '@hotwired/stimulus';

/**
 * Auto submit - submits the form a moment after the user stops typing or toggles a control.
 * Values: delay (Number, ms)
 * @example <form data-controller="auto-submit"><input data-action="input->auto-submit#submit"></form>
 */
export default class extends Controller {
  static values = { delay: { type: Number, default: 350 } };

  submit () {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue);
  }

  disconnect () {
    clearTimeout(this.timeout);
  }
}
